module.exports = __webpack_public_path__ + "img/invitation_alert@3x.ff53458a.png";